import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AnlassCampaignResource } from "@exonn/js-sdk";

/**
 * Anlasskampagnen — кампании, которые отправляются сами, когда у клиента
 * наступает повод (пока — день рождения). В отличие от Werbeaktion здесь нет
 * «Jetzt senden»: активная кампания работает автоматически, вручную
 * запускается только Testlauf на тестовую группу.
 */
export const module: ModuleOptions<AnlassCampaignResource> = {
  resource: ResourceEnum.AnlassCampaign,
  bigIcon: <i className="icon-20-marketing" />,
  smallIcon: <i className="icon-15-market_comp" />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    email: {
      title: (t) => t("formTabs.email.title"),
    },
    sms: {
      title: (t) => t("formTabs.sms.title"),
    },
    whatsapp: {
      title: (t) => t("formTabs.whatsapp.title"),
      // DEC-042: канал в этой поставке не включается — вкладка скрыта.
      isHidden: () => true,
    },
    printMailing: {
      title: (t) => t("formTabs.print-mailing.title"),
      // Подключение PMA пока не заказано — вкладка скрыта.
      isHidden: () => true,
    },
    epost: {
      title: (t) => t("formTabs.epost.title"),
    },
    history: {
      title: (t) => t("formTabs.history.title"),
    },
  },
};
